// extracted by mini-css-extract-plugin
export default {"logout":"Logout_logout__bX7ZB"};